import { FormItemProps } from 'antd/lib/form';
import { IWidgetInput } from 'common/schema/widget/input/WidgetInput';
import { IWidget } from 'common/schema/widget/Widget';
import { WidgetLayout } from 'common/schema/widget/WidgetLayout';
import { getWidgetInputLayout } from '../../helper/getWidgetInputLayout';

export function getWidgetLayoutFromSetup(input: Maybe<IWidgetInput>) {
  // TODO Al momento supportato solo sugli input
  if (!input) return {};

  switch (input.extra?.layout) {
    case WidgetLayout.Horizontal: {
      return getWidgetInputLayout();
    }

    case WidgetLayout.Vertical: {
      return {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 }
      };
    }

    case WidgetLayout.Default:
    default:
      return {};
  }
}
